import { render, staticRenderFns } from "./customer-iv-management.vue?vue&type=template&id=125d962e"
import script from "./customer-iv-management.vue?vue&type=script&lang=ts"
export * from "./customer-iv-management.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports